import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { programService } from "../../services/program.service";
import { ProgramRequest } from "../../domain/program.interface";

const { findProgramsByAccountId, patchProgramSetting, createProgram } =
	programService;

export const useGetProgramsByAccountId = () => {
	return useQuery({
		queryKey: ["sims-users-programs"],
		queryFn: () => findProgramsByAccountId(),
		staleTime: 1000 * 60 * 60 * 24 * 7,
	});
};

export const usePatchProgramSetting = (
	programId: string,
	todayDateAndTime: Date | null,
) => {
	return useMutation({
		mutationFn: () => patchProgramSetting(programId, todayDateAndTime),
	});
};

// New hooks for CRUD operations
export const useGetPrograms = (accountId: string) => {
	return useQuery({
		queryKey: ["programs", accountId],
		queryFn: () => findProgramsByAccountId(),
		enabled: !!accountId,
	});
};

export const useCreateProgram = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			accountId,
			programData,
		}: {
			accountId: string;
			programData: ProgramRequest;
		}) => createProgram(accountId, programData),
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({
				queryKey: ["programs", variables.accountId],
			});
		},
	});
};

export const useUpdateProgram = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			programId,
			programData,
		}: {
			programId: string;
			programData: ProgramRequest;
		}) => programService.updateProgram(programId, programData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["programs"] });
		},
	});
};
